export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'support_manage',
  'knowledge_base_manage',
  'imoveis_manage',
  'visitas_manage',
  'captacao_manage',
  'financeiro_view',
  'financeiro_manage',
  'vitrine_manage',
  'leads_manage',
  'leads_send_crm',
  'chaves_manage',
  'agency_manage',
  'partners_manage',
  'manutencao_view',
  'manutencao_manage',
  'apoio_manage',
  'data_registry_view',
  'data_registry_manage',
  'data_registry_sensitive_view',
  'post_sale_view',
  'post_sale_manage',
  'post_sale_assign',
  'post_sale_status_change',
  'transactions_view',
  'transactions_manage',
  'gamification_view',
  'gamification_participate',
  'gamification_manage',
  'gamification_adjust',
  'gamification_configure',
];

export const ROLES = ['agent', 'administrator'];
export const CAPTADOR_PERMISSION = 'captador';

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';
export const SUPPORT_MANAGE_PERMISSION = 'support_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const IMOVEIS_MANAGE_PERMISSION = 'imoveis_manage';
export const VISITAS_MANAGE_PERMISSION = 'visitas_manage';
export const CAPTACAO_MANAGE_PERMISSION = 'captacao_manage';
export const FINANCEIRO_VIEW_PERMISSION = 'financeiro_view';
export const FINANCEIRO_MANAGE_PERMISSION = 'financeiro_manage';
export const APOIO_MANAGE_PERMISSION = 'apoio_manage';
export const VITRINE_MANAGE_PERMISSION = 'vitrine_manage';
export const LEADS_MANAGE_PERMISSION = 'leads_manage';
export const LEADS_SEND_CRM_PERMISSION = 'leads_send_crm';
export const CHAVES_MANAGE_PERMISSION = 'chaves_manage';
export const AGENCY_MANAGE_PERMISSION = 'agency_manage';
export const PARTNERS_MANAGE_PERMISSION = 'partners_manage';
export const MANUTENCAO_VIEW_PERMISSION = 'manutencao_view';
export const MANUTENCAO_MANAGE_PERMISSION = 'manutencao_manage';
export const DATA_REGISTRY_VIEW_PERMISSION = 'data_registry_view';
export const DATA_REGISTRY_MANAGE_PERMISSION = 'data_registry_manage';
export const DATA_REGISTRY_SENSITIVE_VIEW_PERMISSION =
  'data_registry_sensitive_view';
export const POST_SALE_VIEW_PERMISSION = 'post_sale_view';
export const POST_SALE_MANAGE_PERMISSION = 'post_sale_manage';
export const POST_SALE_ASSIGN_PERMISSION = 'post_sale_assign';
export const POST_SALE_STATUS_CHANGE_PERMISSION = 'post_sale_status_change';
export const TRANSACTIONS_VIEW_PERMISSION = 'transactions_view';
export const TRANSACTIONS_MANAGE_PERMISSION = 'transactions_manage';
export const GAMIFICATION_VIEW_PERMISSION = 'gamification_view';
export const GAMIFICATION_PARTICIPATE_PERMISSION = 'gamification_participate';
export const GAMIFICATION_MANAGE_PERMISSION = 'gamification_manage';
export const GAMIFICATION_ADJUST_PERMISSION = 'gamification_adjust';
export const GAMIFICATION_CONFIGURE_PERMISSION = 'gamification_configure';

export const GAMIFICATION_PERMISSIONS = [
  GAMIFICATION_VIEW_PERMISSION,
  GAMIFICATION_PARTICIPATE_PERMISSION,
  GAMIFICATION_MANAGE_PERMISSION,
  GAMIFICATION_ADJUST_PERMISSION,
  GAMIFICATION_CONFIGURE_PERMISSION,
];

export const REAL_ESTATE_PERMISSIONS = [
  IMOVEIS_MANAGE_PERMISSION,
  VISITAS_MANAGE_PERMISSION,
  CAPTACAO_MANAGE_PERMISSION,
  FINANCEIRO_VIEW_PERMISSION,
  FINANCEIRO_MANAGE_PERMISSION,
  VITRINE_MANAGE_PERMISSION,
  LEADS_MANAGE_PERMISSION,
  LEADS_SEND_CRM_PERMISSION,
  CHAVES_MANAGE_PERMISSION,
  AGENCY_MANAGE_PERMISSION,
  PARTNERS_MANAGE_PERMISSION,
  MANUTENCAO_VIEW_PERMISSION,
  MANUTENCAO_MANAGE_PERMISSION,
];

export const APOIO_PERMISSIONS = [APOIO_MANAGE_PERMISSION];

export const DATA_REGISTRY_PERMISSIONS = [
  DATA_REGISTRY_VIEW_PERMISSION,
  DATA_REGISTRY_MANAGE_PERMISSION,
  DATA_REGISTRY_SENSITIVE_VIEW_PERMISSION,
];

export const POST_SALE_PERMISSIONS = [
  POST_SALE_VIEW_PERMISSION,
  POST_SALE_MANAGE_PERMISSION,
  POST_SALE_ASSIGN_PERMISSION,
  POST_SALE_STATUS_CHANGE_PERMISSION,
];

export const SALES_PERMISSIONS = [
  TRANSACTIONS_VIEW_PERMISSION,
  TRANSACTIONS_MANAGE_PERMISSION,
];

export const OPERATOR_CUSTOM_ROLE_PERMISSIONS = [
  IMOVEIS_MANAGE_PERMISSION,
  VISITAS_MANAGE_PERMISSION,
  FINANCEIRO_VIEW_PERMISSION,
  VITRINE_MANAGE_PERMISSION,
  CHAVES_MANAGE_PERMISSION,
  PARTNERS_MANAGE_PERMISSION,
  MANUTENCAO_VIEW_PERMISSION,
  LEADS_MANAGE_PERMISSION,
  MANAGE_ALL_CONVERSATION_PERMISSIONS,
  CONTACT_PERMISSIONS,
  SUPPORT_MANAGE_PERMISSION,
];

export const CORRETOR_CUSTOM_ROLE_PERMISSIONS = [
  IMOVEIS_MANAGE_PERMISSION,
  VISITAS_MANAGE_PERMISSION,
  CAPTACAO_MANAGE_PERMISSION,
  VITRINE_MANAGE_PERMISSION,
  CHAVES_MANAGE_PERMISSION,
  PARTNERS_MANAGE_PERMISSION,
  MANUTENCAO_VIEW_PERMISSION,
  MANUTENCAO_MANAGE_PERMISSION,
  LEADS_MANAGE_PERMISSION,
  LEADS_SEND_CRM_PERMISSION,
  FINANCEIRO_VIEW_PERMISSION,
  MANAGE_ALL_CONVERSATION_PERMISSIONS,
  CONTACT_PERMISSIONS,
];

export const ADMIN_CUSTOM_ROLE_PERMISSIONS = [
  ...AVAILABLE_CUSTOM_ROLE_PERMISSIONS,
];

export const CUSTOM_ROLE_PRESETS = [
  {
    key: 'OPERATOR',
    permissions: OPERATOR_CUSTOM_ROLE_PERMISSIONS,
  },
  {
    key: 'CORRETOR',
    permissions: CORRETOR_CUSTOM_ROLE_PERMISSIONS,
  },
  {
    key: 'ADMIN',
    permissions: ADMIN_CUSTOM_ROLE_PERMISSIONS,
  },
];

export const CUSTOM_ROLE_PERMISSION_GROUPS = [
  {
    key: 'CONVERSATIONS',
    permissions: CONVERSATION_PERMISSIONS,
  },
  {
    key: 'CORE',
    permissions: [
      CONTACT_PERMISSIONS,
      REPORTS_PERMISSIONS,
      SUPPORT_MANAGE_PERMISSION,
      PORTAL_PERMISSIONS,
    ],
  },
  {
    key: 'REAL_ESTATE',
    permissions: REAL_ESTATE_PERMISSIONS,
  },
  {
    key: 'APOIO',
    permissions: APOIO_PERMISSIONS,
  },
  {
    key: 'DATA_REGISTRY',
    permissions: DATA_REGISTRY_PERMISSIONS,
  },
  {
    key: 'POST_SALE',
    permissions: POST_SALE_PERMISSIONS,
  },
  {
    key: 'SALES',
    permissions: SALES_PERMISSIONS,
  },
];

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};

export const REAL_ESTATE_SURFACES = Object.freeze({
  IMOVEIS_INDEX: 'imoveis_index',
  VISITAS_INDEX: 'visitas_index',
  LEADS_INDEX: 'leads_index',
  PROPERTY_OFFERS_INDEX: 'property_offers_index',
  RENT_FLOWS_INDEX: 'rent_flows_index',
  QPRECO_INDEX: 'qpreco_index',
  FINANCEIRO_INDEX: 'financeiro_index',
  PENDING_MARKET_INDEX: 'pending_market_index',
  REAL_ESTATE_REPORTS_INDEX: 'real_estate_reports_index',
  SUPPORT_TICKETS_INDEX: 'support_tickets_index',
  POST_SALE_INDEX: 'post_sale_index',
  SALES_INDEX: 'sales_index',
});

export const REAL_ESTATE_CAPABILITY_STATES = Object.freeze({
  READY: 'ready',
  PARTIAL: 'partial',
  STALE: 'stale',
  PERMISSION_DENIED: 'permission_denied',
});

const VIEWER_PERMISSIONS = Object.freeze([...ROLES]);
const IMOVEIS_VIEW_PERMISSIONS = Object.freeze([
  ...VIEWER_PERMISSIONS,
  IMOVEIS_MANAGE_PERMISSION,
]);
const VISITAS_VIEW_PERMISSIONS = Object.freeze([
  ...VIEWER_PERMISSIONS,
  VISITAS_MANAGE_PERMISSION,
  CHAVES_MANAGE_PERMISSION,
]);
const LEADS_VIEW_PERMISSIONS = Object.freeze([
  ...VIEWER_PERMISSIONS,
  LEADS_MANAGE_PERMISSION,
]);
const CAPTACAO_VIEW_PERMISSIONS = Object.freeze([
  ...VIEWER_PERMISSIONS,
  CAPTADOR_PERMISSION,
  CAPTACAO_MANAGE_PERMISSION,
]);
const FINANCEIRO_VIEW_PERMISSIONS = Object.freeze([
  ...VIEWER_PERMISSIONS,
  FINANCEIRO_VIEW_PERMISSION,
]);
const SUPPORT_VIEW_PERMISSIONS = Object.freeze([
  ...VIEWER_PERMISSIONS,
  SUPPORT_MANAGE_PERMISSION,
  'custom_role',
]);
const POST_SALE_VIEW_PERMISSIONS = Object.freeze([
  ...VIEWER_PERMISSIONS,
  POST_SALE_VIEW_PERMISSION,
  POST_SALE_MANAGE_PERMISSION,
  POST_SALE_ASSIGN_PERMISSION,
  POST_SALE_STATUS_CHANGE_PERMISSION,
]);
const REPORT_VIEW_PERMISSIONS = Object.freeze([
  ...VIEWER_PERMISSIONS,
  REPORTS_PERMISSIONS,
]);

export const REAL_ESTATE_CAPABILITY_MATRIX = Object.freeze({
  [REAL_ESTATE_SURFACES.IMOVEIS_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['imoveis.index.view'],
      permissions: IMOVEIS_VIEW_PERMISSIONS,
    }),
    filters: Object.freeze({
      capabilityIds: ['imoveis.index.filters'],
      permissions: IMOVEIS_VIEW_PERMISSIONS,
    }),
    create: Object.freeze({
      capabilityIds: ['imoveis.create'],
      permissions: [IMOVEIS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    import_console: Object.freeze({
      capabilityIds: ['imoveis.import.manage'],
      permissions: [IMOVEIS_MANAGE_PERMISSION],
    }),
    import_start: Object.freeze({
      capabilityIds: ['imoveis.import.start'],
      permissions: [IMOVEIS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    duplicate_candidates: Object.freeze({
      capabilityIds: ['imoveis.duplicates.review'],
      permissions: [IMOVEIS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    portal_sync_operations: Object.freeze({
      capabilityIds: ['imoveis.portal_sync.review'],
      permissions: [IMOVEIS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    publication_queue: Object.freeze({
      capabilityIds: ['imoveis.publication_queue.review'],
      permissions: [IMOVEIS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    bulk_highlight: Object.freeze({
      capabilityIds: ['imoveis.highlight.schedule'],
      permissions: [IMOVEIS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    bulk_export: Object.freeze({
      capabilityIds: ['imoveis.export'],
      permissions: IMOVEIS_VIEW_PERMISSIONS,
    }),
    bulk_send: Object.freeze({
      capabilityIds: ['imoveis.share'],
      permissions: IMOVEIS_VIEW_PERMISSIONS,
    }),
  }),
  [REAL_ESTATE_SURFACES.VISITAS_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['visitas.index.view'],
      permissions: VISITAS_VIEW_PERMISSIONS,
    }),
    agenda: Object.freeze({
      capabilityIds: ['visitas.agenda.view'],
      permissions: VISITAS_VIEW_PERMISSIONS,
    }),
    filters: Object.freeze({
      capabilityIds: ['visitas.index.filters'],
      permissions: VISITAS_VIEW_PERMISSIONS,
    }),
    create: Object.freeze({
      capabilityIds: ['visitas.create'],
      permissions: [VISITAS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    confirm: Object.freeze({
      capabilityIds: ['visitas.confirm'],
      permissions: [VISITAS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    cancel: Object.freeze({
      capabilityIds: ['visitas.cancel'],
      permissions: [VISITAS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    finish: Object.freeze({
      capabilityIds: ['visitas.finish'],
      permissions: [VISITAS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    review: Object.freeze({
      capabilityIds: ['visitas.review'],
      permissions: [VISITAS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    reschedule: Object.freeze({
      capabilityIds: ['visitas.reschedule'],
      permissions: [VISITAS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    availability: Object.freeze({
      capabilityIds: ['visitas.availability.manage'],
      permissions: [VISITAS_MANAGE_PERMISSION, CHAVES_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    suspend_listing: Object.freeze({
      capabilityIds: ['visitas.listing_suspension.manage'],
      permissions: [VISITAS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    quick_message: Object.freeze({
      capabilityIds: ['visitas.quick_message.send'],
      permissions: VISITAS_VIEW_PERMISSIONS,
    }),
    offer: Object.freeze({
      capabilityIds: ['visitas.offer.send'],
      permissions: [VISITAS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
  }),
  [REAL_ESTATE_SURFACES.LEADS_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['leads.index.view'],
      permissions: LEADS_VIEW_PERMISSIONS,
    }),
    pipeline: Object.freeze({
      capabilityIds: ['leads.pipeline.view'],
      permissions: LEADS_VIEW_PERMISSIONS,
    }),
    filters: Object.freeze({
      capabilityIds: ['leads.index.filters'],
      permissions: LEADS_VIEW_PERMISSIONS,
    }),
    referrals: Object.freeze({
      capabilityIds: ['leads.referrals.view'],
      permissions: [LEADS_SEND_CRM_PERMISSION],
    }),
    export_selected: Object.freeze({
      capabilityIds: ['leads.export.selected'],
      permissions: LEADS_VIEW_PERMISSIONS,
    }),
    export_filtered: Object.freeze({
      capabilityIds: ['leads.export.filtered'],
      permissions: LEADS_VIEW_PERMISSIONS,
    }),
    send_crm: Object.freeze({
      capabilityIds: ['leads.crm.send'],
      permissions: [LEADS_SEND_CRM_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    remarketing: Object.freeze({
      capabilityIds: ['leads.remarketing.schedule'],
      permissions: [LEADS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    edit: Object.freeze({
      capabilityIds: ['leads.edit'],
      permissions: [LEADS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    delete: Object.freeze({
      capabilityIds: ['leads.delete'],
      permissions: [LEADS_MANAGE_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    quick_view: Object.freeze({
      capabilityIds: ['leads.quick_view'],
      permissions: LEADS_VIEW_PERMISSIONS,
    }),
  }),
  [REAL_ESTATE_SURFACES.PROPERTY_OFFERS_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['offers.index.view'],
      permissions: VIEWER_PERMISSIONS,
    }),
    create_revision: Object.freeze({
      capabilityIds: ['offers.revisions.create'],
      permissions: VIEWER_PERMISSIONS,
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    accept: Object.freeze({
      capabilityIds: ['offers.accept'],
      permissions: VIEWER_PERMISSIONS,
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    contract_status: Object.freeze({
      capabilityIds: ['offers.contracts.view'],
      permissions: VIEWER_PERMISSIONS,
    }),
  }),
  [REAL_ESTATE_SURFACES.RENT_FLOWS_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['leases.index.view'],
      permissions: VIEWER_PERMISSIONS,
    }),
    maintenance: Object.freeze({
      capabilityIds: ['leases.maintenance.manage'],
      permissions: SUPPORT_VIEW_PERMISSIONS,
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    partner_board: Object.freeze({
      capabilityIds: ['leases.partners.work_orders.view'],
      permissions: SUPPORT_VIEW_PERMISSIONS,
    }),
  }),
  [REAL_ESTATE_SURFACES.QPRECO_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['qpreco.index.view'],
      permissions: VIEWER_PERMISSIONS,
    }),
    create_case: Object.freeze({
      capabilityIds: ['qpreco.valuation_cases.create'],
      permissions: VIEWER_PERMISSIONS,
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    share_report: Object.freeze({
      capabilityIds: ['qpreco.reports.share'],
      permissions: ['administrator', FINANCEIRO_VIEW_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
  }),
  [REAL_ESTATE_SURFACES.FINANCEIRO_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['financeiro.index.view'],
      permissions: FINANCEIRO_VIEW_PERMISSIONS,
    }),
    export: Object.freeze({
      capabilityIds: ['financeiro.export'],
      permissions: ['administrator', FINANCEIRO_VIEW_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    settle_commission: Object.freeze({
      capabilityIds: ['financeiro.commissions.settle'],
      permissions: ['administrator', FINANCEIRO_VIEW_PERMISSION],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
  }),
  [REAL_ESTATE_SURFACES.PENDING_MARKET_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['mercado.pending.view'],
      permissions: CAPTACAO_VIEW_PERMISSIONS,
    }),
    refuse: Object.freeze({
      capabilityIds: ['mercado.pending.refuse'],
      permissions: CAPTACAO_VIEW_PERMISSIONS,
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    sync_status: Object.freeze({
      capabilityIds: ['mercado.pending.sync_status'],
      permissions: CAPTACAO_VIEW_PERMISSIONS,
    }),
  }),
  [REAL_ESTATE_SURFACES.REAL_ESTATE_REPORTS_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['analytics.real_estate_funnel.view'],
      permissions: REPORT_VIEW_PERMISSIONS,
    }),
    export: Object.freeze({
      capabilityIds: ['analytics.real_estate_funnel.export'],
      permissions: REPORT_VIEW_PERMISSIONS,
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
  }),
  [REAL_ESTATE_SURFACES.SUPPORT_TICKETS_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['support_tickets.index.view'],
      permissions: SUPPORT_VIEW_PERMISSIONS,
    }),
    assistance_update: Object.freeze({
      capabilityIds: ['support_tickets.assistance.update'],
      permissions: SUPPORT_VIEW_PERMISSIONS,
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
  }),
  [REAL_ESTATE_SURFACES.POST_SALE_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['post_sale.index.view'],
      permissions: POST_SALE_VIEW_PERMISSIONS,
    }),
    filters: Object.freeze({
      capabilityIds: ['post_sale.index.filters'],
      permissions: POST_SALE_VIEW_PERMISSIONS,
    }),
    assign: Object.freeze({
      capabilityIds: ['post_sale.assign'],
      permissions: [POST_SALE_ASSIGN_PERMISSION, POST_SALE_MANAGE_PERMISSION],
    }),
    transition: Object.freeze({
      capabilityIds: ['post_sale.status.transition'],
      permissions: [
        POST_SALE_STATUS_CHANGE_PERMISSION,
        POST_SALE_MANAGE_PERMISSION,
      ],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
  }),
  [REAL_ESTATE_SURFACES.SALES_INDEX]: Object.freeze({
    view: Object.freeze({
      capabilityIds: ['sales.index.view'],
      permissions: Object.freeze([
        ...VIEWER_PERMISSIONS,
        TRANSACTIONS_VIEW_PERMISSION,
        TRANSACTIONS_MANAGE_PERMISSION,
        POST_SALE_VIEW_PERMISSION,
        POST_SALE_MANAGE_PERMISSION,
      ]),
    }),
    filters: Object.freeze({
      capabilityIds: ['sales.index.filters'],
      permissions: Object.freeze([
        ...VIEWER_PERMISSIONS,
        TRANSACTIONS_VIEW_PERMISSION,
        TRANSACTIONS_MANAGE_PERMISSION,
        POST_SALE_VIEW_PERMISSION,
        POST_SALE_MANAGE_PERMISSION,
      ]),
    }),
    draft_save: Object.freeze({
      capabilityIds: ['sales.draft.save'],
      permissions: [
        TRANSACTIONS_MANAGE_PERMISSION,
        POST_SALE_MANAGE_PERMISSION,
      ],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    archive: Object.freeze({
      capabilityIds: ['sales.archive'],
      permissions: [
        TRANSACTIONS_MANAGE_PERMISSION,
        POST_SALE_MANAGE_PERMISSION,
      ],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    restore: Object.freeze({
      capabilityIds: ['sales.restore'],
      permissions: [
        TRANSACTIONS_MANAGE_PERMISSION,
        POST_SALE_MANAGE_PERMISSION,
      ],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
    finalize: Object.freeze({
      capabilityIds: ['sales.finalize'],
      permissions: [
        TRANSACTIONS_MANAGE_PERMISSION,
        POST_SALE_MANAGE_PERMISSION,
      ],
      disableWhenPartial: true,
      disableWhenStale: true,
    }),
  }),
});
